import React from 'react'

import ControlledModal from '../../../components/modals/ControlledModal'
import EditMinicrudForm from './EditMinicrudForm'
import MinicrudLoader from './_load/MinicrudLoader'
import ModalHeader from './ModalHeader'

const EditMinicrudModal = props => {
  return (
    <ControlledModal width="36rem" {...props}>
      <ModalHeader />
      <MinicrudLoader>
        <EditMinicrudForm />
      </MinicrudLoader>
    </ControlledModal>
  )
}

export default EditMinicrudModal
